module.exports = __webpack_public_path__ + "static/media/03_andinvainthedreamer.2b46b8a8.jpg";